export default __webpack_public_path__ + "static/media/tublianLogo.032088cd.svg";